<template>
  <div>
    <div v-if="userInfo && userInfo.user">
      <StudentHeader v-if="this.userInfo.user.permission == 'student'" />
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <div class="w-full">
      <div
        class="container mx-auto max-w-[1200px]"
        style="min-height: 70vh !important"
      >
        <div class="py-10 px-6" v-if="notificationIndex == null">
          <div class="font-bold text-xl pb-3 flex items-center gap-2">
            Notifications
            <p
              class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
              v-if="notificationData && notificationData.total_count"
            >
              {{ notificationData?.total_count }}
            </p>
          </div>
          <div class="flex flex-col gap-2">
            <div
              v-if="notificationList.length != 0"
              class="mt-2 flex flex-col gap-4"
            >
              <div
                @click="setNotificationTab(index)"
                v-for="(notifi, index) in notificationList"
                :key="notifi.id"
              >
                <div
                  @click="notifyclick(notifi.id)"
                  class="flex justify-between border-2 gap-4 py-4 px-5 rounded-xl cursor-pointer hover:bg-slate-100"
                >
                  <div class="flex items-center gap-3 w-full">
                    <img
                      v-if="notifi.read == true"
                      src="@/assets/newd/Vector(2).svg"
                      class="w-4 h-4"
                      alt=""
                    />

                    <img
                      v-else
                      src="@/assets/newd/Group(1).svg"
                      class="w-4 h-4"
                      alt=""
                    />

                    <p
                      class="text-sm"
                      :class="{
                        'font-bold  ': notifi.read !== true,
                        'font-normal ': notifi.read === true,
                      }"
                    >
                      {{ notifi.topic }}
                    </p>
                  </div>

                  <p class="text-sm flex justify-end">
                    {{
                      new Date(notifi.created_at).toLocaleDateString("en-IN")
                    }}
                  </p>
                </div>
              </div>
            </div>
            <p
              v-if="notificationList.length == 0"
              class="flex flex-col border-2 gap-1 py-4 px-5 rounded-xl cursor-pointer"
            >
              No Notifications
            </p>
          </div>
          <div
            v-if="notificationData.data && notificationData.data.length > 0"
            class="flex justify-center py-4 space-x-2"
          >
            <Pagination
              ref="paginationRef"
              :totalPages="totalPages"
              @page-changed="loadMessages"
            />
          </div>
        </div>

        <div class="py-10 px-6" v-if="notificationIndex != null">
          <button
            @click="triggerPage()"
            class="bg-primary text-xs font-bold text-white px-5 py-1.5 rounded-full"
          >
            Back
          </button>

          <div class="font-bold text-xl ml-2 mt-6 pb-3 flex items-center gap-2">
            {{ selectNotificationData.topic }}
          </div>

          <div class="flex">
            <p
              class="text-xs bg-primary px-3 py-1 rounded-xl text-white ml-2 font-semibold"
            >
              {{
                new Date(selectNotificationData.created_at).toLocaleDateString(
                  "en-IN"
                )
              }}
            </p>
          </div>

          <div class="flex flex-col gap-2 ml-2 mt-4">
            <p class="border-2 rounded-xl px-4 mt-2 py-4 text-sm">
              {{ selectNotificationData.message }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import StudentHeader from "@/components/Student/Header.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Notifications",

  components: {
    StudentHeader,
    Footer,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
  },

  data() {
    return {
      notificationIndex: null,
      selectNotificationData: "",
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
      notificationList: "",
    };
  },

  computed: {
    ...mapGetters(["userInfo", "notificationData"]),
  },

  mounted() {
    this.$store.dispatch("connectWebSocket");
    this.$store.commit("SET_ON_NEW_NOTIFICATION", () => {
      this.loadMessages(this.currentPage);
    });
    this.loadMessages();
  },

  methods: {
    async loadMessages(page = 1) {
      if (!this.userInfo) return;
      const data = await this.$store.dispatch("fetchNotificationList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.notificationList = data.data;
      console.log("test/////////////////000000", this.notificationList);
      this.currentPage = data.current_page;
      this.totalPages = data.total_page;
      this.total_count = data.total;
    },

    ...mapMutations(["notifyCount"]),

    triggerPage() {
      this.notificationIndex = null;
      this.$nextTick(() => {
        if (this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage);
        }
      });
    },

    setNotificationTab(index) {
      this.notificationIndex = index;
      this.selectNotificationData = this.notificationData.data[index];
    },

    notifyclick(id) {
      let formdata = {
        read: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/update-notification/${id}/?Key=${this.userInfo.token_key}`,
          formdata
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.loadMessages(this.currentPage);
          }
        })
        .catch((error) => {
          console.error("Error updating notification:", error);
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
